import React, { useState, useEffect } from 'react';
import { days } from '../../../../../utils/utils';
import classes from './CalendarWeekDates.module.css';

const CalendarWeekDates = ({ selectedDate, onDateSelect, mobile = false }) => {

    const [weekDays, setWeekDays] = useState([]);

    useEffect(() => {
        const getWeekDays = () => {
            const base = new Date(selectedDate);
            base.setDate(base.getDate() - base.getDay());
            const days = Array.from({ length: 7 }, (_, index) => {
                const day = new Date(base);
                day.setDate(base.getDate() + index);
                return day;
            });

            setWeekDays(days);
        };
        getWeekDays();
    }, [selectedDate]);

    const isToday = (date) => {
        const today = new Date();
        return date.toDateString() === today.toDateString();
    };

    const isPast = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const compare = new Date(date);
        compare.setHours(0, 0, 0, 0);
        return compare < today;
    };

    return (
        <div className={`${classes.WeekDates} ${mobile ? classes.Mobile : ''}`}>
            <div className={classes.WeekGrid}>
                {weekDays.map((day, index) => (
                    <div
                        key={index}
                        className={`${classes.DayCell} ${isToday(day) ? classes.Today : ''} ${day.toDateString() === selectedDate.toDateString() ? classes.Selected : ''}`}
                        onClick={(e) => onDateSelect(e, day)}
                    >
                        <div className={classes.DayName}>{days[day.getDay()]}</div>
                        <div className={`${classes.DayNumber} ${mobile && isPast(day) ? classes.Past : ''}`}>
                            {day.getDate()}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CalendarWeekDates;
